import { render, staticRenderFns } from "./CDSSai.vue?vue&type=template&id=ae0d3c36&scoped=true&"
import script from "./CDSSai.vue?vue&type=script&lang=js&"
export * from "./CDSSai.vue?vue&type=script&lang=js&"
import style0 from "./CDSSai.vue?vue&type=style&index=0&id=ae0d3c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0d3c36",
  null
  
)

export default component.exports